import React, { useCallback } from 'react';
import { Checkbox } from '@vtblife/uikit';

import { IsApartmentsOptions } from '@search/filter-enums/enums/IsApartmentsOptions';

import { ApartmentFilter } from '../../../models/Filter';
import { CheckboxGroup2 } from '../../common/CheckboxGroup2';

interface IApartmentButtonFilterView {
    filter: ApartmentFilter;
    handleChange: (filter: ApartmentFilter) => void;
    classNameGroup?: string;
}

const apartmentsMapping: Record<string, string> = {
    [IsApartmentsOptions.APARTMENTS_ONLY]: 'Только апартаменты',
    [IsApartmentsOptions.NO_APARTMENTS]: 'Без апартаментов'
};

const apartmentEnumeration: IsApartmentsOptions[] = [
    IsApartmentsOptions.APARTMENTS_ONLY,
    IsApartmentsOptions.NO_APARTMENTS
];

export const ApartmentButtonFilterView: React.FC<IApartmentButtonFilterView> = ({
    filter,
    handleChange,
    classNameGroup
}) => {
    const onChange = useCallback(val => {
        handleChange(new ApartmentFilter(val));
    }, [ handleChange ]);

    return (
        <div className={classNameGroup}>
            <CheckboxGroup2
                mode='radio-check'
                name='apartment'
                onChange={onChange}
                value={[ filter.isApartment ].map(elem => String(elem))}
                isFilter
            >
                {apartmentEnumeration.map(apartment => {
                    return (
                        <Checkbox
                            variant='filter'
                            key={apartment}
                            name={String(apartment)}
                            block
                            dataTest='apartment'
                        >
                            {apartmentsMapping[apartment]}
                        </Checkbox>
                    );
                })}
            </CheckboxGroup2>
        </div>
    );
};
